import styled from 'styled-components';

export const PrivacyInformationsWrapper = styled.div`
  color: #767676;
  text-align: center;
  font-size: 10px;

  & p {
    text-align: center;
    font-size: 10px;
  }
`;
